import React from "react";
import Link from "@insightfulscience/atomic-react/Link";

export const PageNavbarSearchLink = ({ ...props }) => (
	<Link
		sx={{ fontColor: "black", hover: { fontColor: "3" } }}
		className="text-underline"
		{...props}
	/>
);
